import {
  Input,
  Menu,
  MenuButton,
  MenuGroup,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import moment from "moment";
import { dateForAPI } from "../../../constants/dataFormat";
import { useRecoilState } from "recoil";
import { customColors } from "../../../atoms/customColors";

export default function DateDropdown({
  setDateF,
  setDateI,
  dateF,
  dateI,
  setSelected,
  selected,
}: any) {
  const colors = useRecoilState(customColors)[0];

  return (
    <Menu closeOnSelect={false} placement={"left-start"}>
      <MenuButton
        bgColor={selected === "p" ? "#E2E8F0" : "none"}
        mx={"2px"}
        px={"0.6vw"}
        color={colors.GRAY_DARKER}
        fontWeight={"600"}
        // minHeight={"35px"}
        borderRadius={"6px"}
        _hover={{ bgColor: "#E2E8F0" }}
        fontSize={"0.8vw"}
        h={"30px"}
        // w={"80px"}
        
      >
        {
          selected === "p" ? 
          `${moment(dateI).format("DD/MM")} - ${moment(dateF).format("DD/MM")}`
          :
          "Personalizado"
        }
      </MenuButton>
      <MenuList width={"1vw"}>
        <MenuGroup title={"Data"} fontSize={"1.2vw"}>
          <MenuItem bgColor={selected === "h" ? "#E2E8F0" : "none"} fontSize={"1vw"}>
            <Text
              color={colors.VARIANT}
              onClick={(e: any) => {
                setDateI(
                  moment(e.targetvalue).startOf("day").format(dateForAPI)
                );
                setDateF(moment(e.targetvalue).endOf("day").format(dateForAPI));
                setSelected("h");
              }}
            >
              HOJE
            </Text>
          </MenuItem>
          <MenuItem bgColor={selected === "o" ? "#E2E8F0" : "none"} fontSize={"1vw"}>
            <Text
              color={colors.VARIANT}
              onClick={(e: any) => {
                setDateI(
                  moment(e.targetvalue)
                    .add(-1, "day")
                    .startOf("day")
                    .format(dateForAPI)
                );
                setDateF(
                  moment(e.targetvalue)
                    .add(-1, "day")
                    .endOf("day")
                    .format(dateForAPI)
                );
                setSelected("o");
              }}
            >
              ONTEM
            </Text>
          </MenuItem>
          <MenuItem bgColor={selected === "7d" ? "#E2E8F0" : "none"} fontSize={"1vw"}>
            <Text
              color={colors.VARIANT}
              onClick={(e: any) => {
                setDateI(
                  moment(e.targetvalue)
                    .add(-7, "day")
                    .startOf("day")
                    .format(dateForAPI)
                );
                setDateF(moment(e.targetvalue).endOf("day").format(dateForAPI));
                setSelected("7d");
              }}
            >
              ÚLTIMOS 7 DIAS
            </Text>
          </MenuItem>
          <MenuItem bgColor={selected === "15d" ? "#E2E8F0" : "none"} fontSize={"1vw"}>
            <Text
              color={colors.VARIANT}
              onClick={(e: any) => {
                setDateI(
                  moment(e.targetvalue)
                    .add(-15, "day")
                    .startOf("day")
                    .format(dateForAPI)
                );
                setDateF(moment(e.targetvalue).endOf("day").format(dateForAPI));
                setSelected("15d");
              }}
            >
              ÚLTIMOS 15 DIAS
            </Text>
          </MenuItem>
          <MenuItem bgColor={selected === "30d" ? "#E2E8F0" : "none"} fontSize={"1vw"}>
            <Text
              color={colors.VARIANT}
              onClick={(e: any) => {
                setDateI(
                  moment(e.targetvalue)
                    .add(-30, "day")
                    .startOf("day")
                    .format(dateForAPI)
                );
                setDateF(moment(e.targetvalue).endOf("day").format(dateForAPI));
                setSelected("p");
              }}
            >
              ÚLTIMOS 30 DIAS
            </Text>
          </MenuItem>
        </MenuGroup>
        <MenuGroup title={"De"} fontSize={"1vw"}>
          <MenuItem fontSize={"1vw"}>
            <Input
              fontSize={"1.2vw"}
              type="date"
              w={"20vw"}
              value={moment(dateI).format("YYYY-MM-DD")}
              onChange={(e: any) => {
                setDateI(moment(e.target.value).startOf("day").format(dateForAPI));
                setSelected("p");
              }}
            />
          </MenuItem>
        </MenuGroup>
        <MenuGroup title={"Até "} fontSize={"1vw"}>
          <MenuItem>
            <Input
              fontSize={"1.2vw"}
              type="date"
              w={"20vw"}
              value={moment(dateF).format("YYYY-MM-DD")}
              onChange={(e: any) => {
                setDateF(moment(e.target.value).endOf("day").format(dateForAPI));
                setSelected("p");
              }}
            />
          </MenuItem>
        </MenuGroup>
      </MenuList>
    </Menu>
  );
}
